import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  resolutions: [], // Empty initially, can be populated dynamically
  currentResolution: null, // No default, selected dynamically
};

const resolutionSlice = createSlice({
  name: "resolution",
  initialState,
  reducers: {
    setCurrentResolution: (state, action) => {
      state.currentResolution = action.payload;
    },
    addResolution: (state, action) => {
      if (
        !state.resolutions.some((res) => res.value === action.payload.value)
      ) {
        state.resolutions.push(action.payload);
      }
    },
    setResolutionsList: (state, action) => {
      state.resolutions = action.payload;
    },
  },
});

export const { setCurrentResolution, addResolution, setResolutionsList } =
  resolutionSlice.actions;
export default resolutionSlice.reducer;
